import { useEffect, useMemo, useRef, useState } from "react";
// import { useTranslation } from "react-i18next";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import LinkLoginUserButton from "../Buttons/LinkLoginUserButton";
import Loader from "../Loader/Loader";
// import Logo from "../HeaderLogo/Logo";
import i18next from "i18next";
import { ToastContainer } from "react-toastify";
import { Tooltip } from "react-tooltip";
import useSelectedStore from "../../hooks/useSelectedStore";
import { SETCARTOPENSTATUS } from "../../redux/features/CartData";
import { SETISSHOWMOBILESEARCH } from "../../redux/features/common";
import { setStoreCloseModal } from "../../redux/features/store";
import { getCookie, IsNullUndefine } from "../../utils/helper";
import Konsole from "../../utils/konsole/Konsole";
import ParseFloat from "../../utils/ParseFloat";
import storeStatus from "../../utils/Store/storeStatus";
import { BackButton } from "../../Wrapper/MyInfoWrapper";
import Logo from "../HeaderLogo/Logo";
import NoInternet from "../Modal/NoInternet";
import StoreClose from "../Modal/StoreClose";
import CartItemDetail from "../RightSideBar/CartItemDetail/CartItemDetail";
import { ErrorToast } from "../ToastComponent/ErrorToast";
import HeaderProfilPic from "./HeaderProfilePic";
import HeaderSearch from "./HeaderSearch";
import MobileHeaderSearch from "./MobileHeaderSearch";
// import HeaderMenu from "./menu/HeaderMenu";
import { HEADER_MENU_1 } from "../../constant/constant";

export const pathForSearchBar = ["/", "menu/", "/menu/", "/menu", undefined];
export default function Header({ handleSidebar }: any) {
  const [lang, setLang] = useState(i18next.language);
  const { translations }: any = useSelector(
    (state: any) => state?.languageData
  );
  const dispatch = useDispatch();
  const redux_data = useSelector((state: any) => state);
  const { itemCount, isCartOpen, totalPrice } = redux_data.cartData;
  const { isShowStoreNameHeader, isShowMobileSearch } = redux_data.commonData;
  const user = useSelector((state: any) => state.userData?.user);
  const { selectedStore, isStoreSelected } = useSelectedStore();
  const cartRef = useRef<any>(null); // Ref for cart sidebar, typing it as a div element
  const { t } = useTranslation();
  const returnIsStoreClose = storeStatus();

  const timeoutRef = useRef<any>(null);
  useEffect(() => {
    if (isCartOpen) {
      document.body.classList.add("mobile-overflow");
    }
    if (!isCartOpen) {
      document.body.classList.remove("mobile-overflow");
    }
  }, [isCartOpen]);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    if (itemCount > 0) {
      setIsTooltipOpen(true);

      const msg = `${itemCount} ${itemCount === 1 ? "Item" : "Items"
        }. ${parseFloat(totalPrice || 0)?.toFixed(2)}`;
      setToopTipContent(msg);
      setPrevItemCount(itemCount);

      timeoutRef.current = setTimeout(() => {
        setIsTooltipOpen(false);
      }, 5000);
    } else {
      setIsTooltipOpen(false);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [itemCount]);

  const handleOpenStoreCloseModal = () => {
    dispatch(setStoreCloseModal(true));
  };

  const returnToken = useMemo(() => {
    // return localStorage.getItem("yop-token");
    return getCookie("yop-token");
  }, []);
  const location = useLocation();

  useEffect(() => {
    document.title = selectedStore?.store_name ?? "Yop";
    Konsole.log("selectedStore", selectedStore);
  }, [selectedStore]);

  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const [prevItemCount, setPrevItemCount] = useState(0);
  const [tooltipContent, setToopTipContent] = useState("");

  useEffect(() => {
    setIsTooltipOpen(true);
    let msg = `${itemCount} ${itemCount == 1 ? "Item" : "Items"}. ${ParseFloat(
      totalPrice || 0
    )}`;

    setToopTipContent(msg); // setToopTipContent(itemCount > prevItemCount ? `${itemCount}` : 'Remove Item')
    setPrevItemCount(itemCount);
    setTimeout(() => {
      setIsTooltipOpen(false);
    }, 5000);
  }, [itemCount]);
  function myCart() {
    if (returnIsStoreClose) {
      handleOpenStoreCloseModal();
      return;
    }
    if (itemCount == 0) {
      ErrorToast(t("CartDetails.pleaseSelectAtLeastOneItem"));
      return;
    } else {
      // navigation("/checkout");
      dispatch(SETCARTOPENSTATUS(!isCartOpen));
    }
  }

  const updateShowMobileSearch = (val: any) => {
    dispatch(SETISSHOWMOBILESEARCH(val));
  };



  // Close the cart if the click is outside of the cart
  // useEffect(() => {
  //   const handleClickOutside = (event: MouseEvent) => {
  //     // Check if the click is outside the cart sidebar
  //     if (cartRef.current && !cartRef.current.contains(event.target as Node)) {
  //       dispatch(SETCARTOPENSTATUS(false)); // Close cart if clicked outside
  //     }
  //   };
  //   // Add event listener on mount
  //   document.addEventListener("mousedown", handleClickOutside);
  //   // Cleanup event listener on unmount
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, []);

  return (
    <>
      <Loader />

      {isShowMobileSearch ? (
        <MobileHeaderSearch updateShowMobileSearch={updateShowMobileSearch} />) : ''}
      <>
        <NoInternet />
        {/* <AcceptCookie /> */}
        <ToastContainer style={{ zIndex: "99999" }} hideProgressBar={true} />
        <div className="flex justify-between items-center md:px-10 px-3 container mx-auto" >

          <div className="flex gap-4 items-center">
            {/* <Logo /> */}
            {HEADER_MENU_1.includes(location?.pathname) ? (
              <> {" "} <BackButton to="/menu" />{" "}
                <span className="pt-1">{t("CartDetails.back")}</span>{" "}
              </>
            ) : (
              <Logo />
            )}
          </div>

          {/* {!HEADER_MENU_2.includes(location?.pathname) &&
            <HeaderMenu pathName={location.pathname} />
          } */}
          {/* @@start display store _name */}
          {isShowStoreNameHeader &&
            selectedStore?.store_name &&
            location.pathname !== "/checkout" && (
              <p className="text-xl font-splekta font-normal slide-up-animation">
                {selectedStore?.store_name}
              </p>
            )}


          <div className="flex md:gap-4 items-center justify-between">
            {isStoreSelected &&
              <div>
                {pathForSearchBar.includes(location?.pathname) ? (<HeaderSearch />) : ("")}
              </div>
            }
            {location.pathname !== "/login" &&
              location.pathname !== "/register" &&
              location.pathname !== "/verify-otp" && (
                <>

                  {isStoreSelected &&
                    <div className="hidden md:inline-flex">
                      {location.pathname !== "/checkout" ? (
                        <>
                          {/* @@ toltip for item add delete */}
                          <Tooltip id="my-tooltip" isOpen={isTooltipOpen} />
                          <a data-tooltip-id="my-tooltip" data-tooltip-content={tooltipContent}>
                            <div onClick={myCart} className="btn btnBlue loginIcon text-white bgBlue font-medium rounded-[7px] text-center inline-flex items-center justify-center cursor-pointer hidden sm:inline-flex">
                              <svg className="w-3.5 h-3.5 me-2 font-bold" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 18 21">
                                <path d="M15 12a1 1 0 0 0 .962-.726l2-7A1 1 0 0 0 17 3H3.77L3.175.745A1 1 0 0 0 2.208 0H1a1 1 0 0 0 0 2h.438l.6 2.255v.019l2 7 .746 2.986A3 3 0 1 0 9 17a2.966 2.966 0 0 0-.184-1h2.368c-.118.32-.18.659-.184 1a3 3 0 1 0 3-3H6.78l-.5-2H15Z" />
                              </svg>
                              <span style={{ paddingTop: "0.15rem" }}>
                                {ParseFloat(totalPrice || 0)} {" | "}{" "}
                                {itemCount || 0}{" "}
                                {itemCount > 1 ? t("CartDetails.items") : t("CartDetails.item")}
                              </span>
                            </div>
                          </a>
                        </>
                      ) : null}
                    </div>
                  }
    { }
                    {IsNullUndefine(returnToken) &&
                      isShowStoreNameHeader == false &&
                      location.pathname !== "/checkout"  &&
                  <div
                    className="rightButton"
                    onClick={() => {
                      if (!returnToken) {
                        sessionStorage.setItem("previous-page", "/menu");
                      }
                    }}
                  >
                    { }
                    {IsNullUndefine(returnToken) &&
                      isShowStoreNameHeader == false &&
                      location.pathname !== "/checkout" ? (
                      <> <LinkLoginUserButton buttonText="Login" url="/login" btnClass="btnBlue loginIcon" /> </>
                    ) : ("")}
                  </div>
}
                  {/* @@ Prfile pic */}
                  {isShowStoreNameHeader &&
                    selectedStore?.store_name &&
                    pathForSearchBar.includes(location?.pathname) && (
                      <p className="text-xl font-splekta font-normal slide-up-animation">
                        <div className="flex textMd bg-[#f1f1f1] text-[#6A6A6A] rounded-[.5rem] items-center justify-center border-mercury-ui-divider  w-full flex-1 transition-all">
                          <div className="flex" onClick={() => updateShowMobileSearch(true)} >
                            <button className="flex rounded-mercury-ui-control  text-left transition bg-none text-mercury-ui-secondary hover:text-mercury-ui-primary hover:ring-mercury-ui-text-primary/20 hover:ring-3 group my-px xl:my-0 border-mercury-ui-divider h-9 w-9 items-center justify-center focus:outline-hidden" title="Search">
                              <span className="text-mercury-ui-button-base font-mercury-ui-primary block overflow-hidden text-ellipsis whitespace-nowrap">
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                                  <title>Search</title>
                                  <path d="M22.6 20.4 18.2 16c1.1-1.6 1.8-3.5 1.8-5.6C20 5.2 15.7.9 10.5.9S1 5.2 1 10.4s4.3 9.5 9.5 9.5c2.1 0 4-.7 5.6-1.8l4.4 4.4 2.1-2.1ZM4 10.5C4 6.9 6.9 4 10.5 4S17 6.9 17 10.5 14.1 17 10.5 17 4 14.1 4 10.5Z" fill="currentColor"></path>
                                </svg>
                              </span>
                            </button>
                          </div>
                        </div>
                      </p>
                    )}
                  { }
                  {!IsNullUndefine(returnToken) &&
                    isShowStoreNameHeader == false &&
                    location.pathname !== "/checkout" && (
                      <div className={`dropDown search-scroll-hide ${isShowStoreNameHeader && selectedStore?.store_name ? "hidden" : ""}`}>
                        <HeaderProfilPic user={user} handleSidebar={handleSidebar} />
                      </div>
                    )}
                </>
              )}
          </div>
        </div>

        {isCartOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity duration-100"></div>
        )}
        <div
          ref={cartRef}
          className={`fixed top-0 right-0 h-full bg-white z-[51] md:w-[28.75rem] w-full shadow-xl transition-all duration-300 ease-in-out transform ${isCartOpen ? "translate-x-0" : "translate-x-full"
            }`}
          style={{
            transitionProperty: "transform, opacity", opacity: isCartOpen ? 1 : 0, overflow: "hidden", // PREVENT parent from scrolling
          }}
        >
          {/* Scrollable child container */}
          <div className="h-full overflow-y-auto">
            <CartItemDetail />
          </div>
        </div>

      </>


      <StoreClose />
    </>
  );
}
